<template>
    <div class="tab-content">
        <h2 class="tab-content--title">
            {{
                formData
                    ? 'Your Aim'
                    : 'Create an Account'
            }}
        </h2>

        <account-type-step
            v-if="formData"
            :form-data="formData"
            @finish="signUp" />
        <account-credentials-form
            v-else
            submit-label="Sign Up"
            @submit="setCredentials" />
    </div>
</template>

<script>
import AccountCredentialsForm from '@/components/Signup/AccountCredentialsForm';
import AccountTypeStep from '@/components/Signup/AccountTypeStep';
import { redirectIfInIframeMixin } from '@/mixins/redirectIfInIframeMixin';

export default {
    name: 'Signup',

    components: { AccountCredentialsForm, AccountTypeStep },

    mixins: [redirectIfInIframeMixin],

    data() {
        return {
            formData: null,
        };
    },

    methods: {
        signUp(ev) {
            this.$store.dispatch('signUp', {
                ...ev,
                formData: this.formData,
            });
        },

        async setCredentials(formData) {
            const isUserExists = await this.$store.dispatch('checkIfUserExists', formData.email);

            if (isUserExists) {
                this.$store.commit('snackbar', {
                    text: 'User with current email already exists',
                    color: 'error',
                });
            } else {
                this.formData = {
                    ...formData,
                    password: formData.phoneNumber.replace(/[^\d]/g, ''),
                };
            }
        },
    },
};
</script>

<style scoped></style>